import React, { useState, useEffect, useCallback } from 'react'
import * as Yup from 'yup'
import { Formik, Form, Field } from 'formik'
import { useTranslation } from 'react-i18next'
import LayoutWithOutAccountCard from '../../../layout/Layout/layout-without-card'
import PaymentsService from '../../../services/payments.service'
import NeoInput from '../../../components/NeoInput/NeoInput'
import InputError from '../../../components/InputError/InputError'
import NeoLoader from '../../../components/FormComponents/NeoLoader'
import { NeoSuccess } from '../../../components/FormComponents'
import NeoButton from '../../../components/NeoButton/NeoButton'
import Loading from 'custom/assets/loaders/Loading'
import { useHistory } from 'react-router-dom'
import {
  VALIDATION_MESSAGES,
  SIDENAV_KEYS,
  PAYMENT_KEYS,
} from '../../../utils/translation-constants'
import { billersListSelector } from '../../../selectors'
import { useDispatch, useSelector } from 'react-redux'
import { setBillersList } from '../../../actions'
import validationConfig from 'custom/config/validation.config.json'
const addBillerConfig = validationConfig['payment']['addBillerBene'] 

const SERVICE_LABELS = {
  Topstar: 'Meter No.',
  Airtel_Topup: 'Mobile No.',
  Zamtel_Topup: 'Mobile No.',
  MTN_Topup: 'Mobile No.',
  Zesco: 'Meter No.',
  GOtv: 'IUC No.',
  DStv: 'Smart Card No.',
  LiquidTelecom_Data: 'Account No.',
  MTN_Data: 'Account No.',
  Vodafone: 'Account No.',
  MLife: 'Account No.',
  Afribus: 'Service No.',
  ZRA: 'PRN',
}

export default function AddBiller() {
  const [stage, setStage] = useState(0)
  const [selectedBiller, setSelectedBiller] = useState({})
  const [beneList, setBeneList] = useState([])
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const history = useHistory()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [productDetails, setProductDetails] = useState({ products: [] })

  const billersList = useSelector(billersListSelector) || []
  const LABELS = {
    CASHIN: t(PAYMENT_KEYS.MOBILE_NO),
    DATA: t(PAYMENT_KEYS.MOBILE_NO),
    CASHOUT: t(PAYMENT_KEYS.MOBILE_NO),
    TOPUP: t(PAYMENT_KEYS.MOBILE_NO),
    SCHOOLPAY: t(PAYMENT_KEYS.STUDENT_NO),
    DTH: t(PAYMENT_KEYS.SUBSCRIBER_NO),
    WATER: t(PAYMENT_KEYS.SERVICE_NO),
    ELECTRICITY: t(PAYMENT_KEYS.BILL_NUMBER),
    INTERNET: t(PAYMENT_KEYS.ACCOUNT_NO),
    INSURANCE: t(PAYMENT_KEYS.INSURANCE_NO),
    TRAVEL:t(PAYMENT_KEYS.MOBILE_NO),
    TAX:t(PAYMENT_KEYS.SERVICE_NO),
  }

  useEffect(() => {
    fetchBillersAndAccounts()
  }, [])

  const getProductDetails = useCallback(async (serviceId) => {
    try {
      setLoading(true)
      const response = await PaymentsService.getServiceById({
        fetchProducts: true,
        serviceId: serviceId,
      })
      if (response.status === 200) {
        setProductDetails(response.data)
        setLoading(false)
      }
    } catch (err) {
      setMessage(err)
    }
  }, [])

  const fetchBillersAndAccounts = useCallback(async () => {
    try {
      if (billersList.length === 0) {
        setLoading(true)
        const response = await PaymentsService.getAllBillers({
          fetchServices: true,
          fetchProducts: true,
        })
        if (response.status === 200) {
          setLoading(false)
          dispatch(setBillersList(response.data['categories']))

          const serviceList = []
          response.data['categories'].forEach((element) => {
            serviceList.push(...element.services)
          })
          setBeneList([...serviceList])
          setStage(1)
        }
      } else {
        if (billersList?.length > 0) {
          const serviceList = []
          billersList.forEach((element) => {
            serviceList.push(...element.services)
          })
          setBeneList([...serviceList])
          setStage(1)
        }
      }
    } catch (err) {
      setLoading(false)
    }
  }, [])

  const submitAddBillerForm = useCallback(
    async (data, { setSubmitting }) => {
      try {
        setLoading(true)
        setSubmitting(true)
        const billerDetails = beneList.filter((biller) => biller.description === data.merchant)[0]
        const response = await PaymentsService.addBillerBeneficiary({
          merchant: billerDetails.merchantId,
          serviceId: billerDetails.serviceId,
          serviceNumber: data.serviceNumber,
          shortName: data.shortName,
        })
        if (response.status === 200) {
          setMessage(response.data['message'])
          setLoading(false)
          setSubmitting(false)
          setStage(2)
        }
        // hideModal()
        // hideAddBillerBeneModal()
        // setMessage(response.message)
        // setError({ code: response.code, message: response.message })
        // showModal()
        // setLoading(false)
      } catch (err) {
        // hideModal()
        // hideAddBillerBeneModal()
        // // setMessage(err.errors === undefined ? err.message : err.errors.join('\n'))
        setLoading(false)
        setSubmitting(false)
      }
    },
    [beneList],
  )

  const setSelectedBillerCallback = useCallback(
    async(billerName) => {
      let billerDetails=beneList.filter((value) => value.description === billerName)[0]
      setSelectedBiller(billerDetails)
      await getProductDetails(billerDetails.serviceId)
    },
    [beneList, selectedBiller],
  )

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderForm()
      case 2:
        return <NeoSuccess message={message} linkPath='/payments/biller-list' />
      default:
        return renderForm()
    }
  }

  const AddBillerFormSchema = Yup.object().shape({
    merchant: Yup.string().required(t(VALIDATION_MESSAGES.MERCHANT)),
    serviceNumber: Yup.string().required(
      `${LABELS[productDetails?.category] || t(PAYMENT_KEYS.SERVICE_NO)} ${t(
        PAYMENT_KEYS.IS_REQUIRED,
      )}`,
    ),
    shortName: Yup.string()
      .required(t(VALIDATION_MESSAGES.SHORT_NAME))
      .min(2, t(VALIDATION_MESSAGES.SHORT_NAME_VALID))
      .max(20, t(VALIDATION_MESSAGES.SHORT_NAME_VALID)),
  })

  function renderForm() {
    return (
      <>
        <Formik
          enableReinitialize
          initialValues={{
            merchant: '',
            serviceNumber: '',
            shortName: '',
          }}
          onSubmit={submitAddBillerForm}
          validationSchema={AddBillerFormSchema}>
          {({ isSubmitting, touched, errors, handleChange, setFieldValue, values }) => (
            <Form>
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='1'
                    showAsterisk={addBillerConfig["isServiceRequired"]}
                    mode='select'
                    name='merchant'
                    text={t(PAYMENT_KEYS.SELECT_MERCHANT)}
                    onChange={(e) => {
                      handleChange(e)
                      setFieldValue('serviceNumber', '')
                      setSelectedBillerCallback(e.target.value)
                    }}
                    list={beneList}
                    keyValue='description'
                  />
                  <InputError text={errors.merchant} touched={touched.merchant} />
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='2'
                    text={LABELS[productDetails?.category] || t(PAYMENT_KEYS.SERVICE_NO)}
                    showAsterisk={addBillerConfig["isServiceNoRequired"]}
                    onChange={handleChange}
                    name='serviceNumber'
                    maxLength={18}
                  />
                  <InputError text={errors.serviceNumber} touched={touched.serviceNumber} />
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='3'
                    showAsterisk={addBillerConfig["isShortNameRequired"]}
                    text={t(PAYMENT_KEYS.SHORT_NAME)}
                    onChange={handleChange}
                    name='shortName'
                    onKeyPress={(event) => {
                      if (
                        !(event.charCode >= 65 && event.charCode <= 90) &&
                        !(event.charCode >= 97 && event.charCode <= 122) &&
                        event.charCode !== 32
                      ) {
                        event.preventDefault()
                      }
                    }}
                  />
                  <InputError text={errors.shortName} touched={touched.shortName} />
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-12'>
                  {isSubmitting ? (
                    <NeoLoader />
                  ) : (
                    <NeoButton
                      tabIndex='4'
                      type='submit'
                      mode='newDesign'
                      disabled={isSubmitting}
                      text={t(PAYMENT_KEYS.SUBMIT)}
                    />
                  )}
                </div>
              </div>
              <div className='back-cancel-btn-container'>
              <button className='back-cancel-btn btn btn-sm new-design-warning-text-color' tabIndex={'5'} onClick={() => history.goBack()}>
                {' '}
                {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
              </button>
              </div>
            </Form>
          )}
        </Formik>
      </>
    )
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard breadCumKey='ADD_BILLER' showEmptySpace={true} keyPath={'ADD_BILLER'}>
      <div className='new-design-form-style'>
        <div className='heading-style'>{t(PAYMENT_KEYS.TITLE)}</div>
        {renderSwitch()}
      </div>
    </LayoutWithOutAccountCard>
  )
}
